export const APP_TOKEN = 'IMBB.token';
